<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useAppState } from '../../store/state';
import { defineComponent } from 'vue';
import LinkView from '../LinkView.vue';
import TextView from '../TextView.vue';
import DeviceView from '../DeviceView.vue';
import type { TagType } from '@nfc-api/tag';
import Spinner from '../templates/Spinner.vue';

const metaThemeColor = document.querySelector('meta[name=theme-color]');
metaThemeColor?.setAttribute('content', 'black');

const state = useAppState();
const router = useRouter();

if (!state.tag) 
  router.push({ name: 'not-found' });

const tag = state.tag;

const mapVieComponent: Record<TagType, ReturnType<typeof defineComponent>> = {
  link: LinkView,
  text: TextView,
  device: DeviceView
};

const viewComponent = tag?.type != null ? mapVieComponent[tag?.type] : null;
</script>

<template>
  <div id="wrapper" class="w-full h-full overflow-hidden font-light font-sans bg-black">
    <div class="flex items-center justify-center h-full text-white">
      <div id="content-container" class="max-w-xl flex flex-col items-center w-full md:max-h-3/4 h-full justify-center relative">
        <Suspense>
          <Transition name="fade" mode="out-in" appear>
            <component v-bind:is="viewComponent" :tag="tag" />
          </Transition>
          <template #fallback>
            <Spinner class="w-16 h-16"/>
          </template>
        </Suspense>
      </div>
    </div>
  </div>
</template>

<style>
#wrapper {
  background-image: radial-gradient(rgb(58, 58, 58) 1px, transparent 0);
  background-size: 20px 20px;
  background-position: -5px -5px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
